<footer class="footer">
  <div class="footer__inner">

    <!-- Brand -->
    <div class="footer__brand">
      <img src="logo.svg" alt="MilkHouse" width="163" height="48" />
      <p class="footer__tagline">Оптова доставка свіжих продуктів</p>
    </div>

    <!-- Contacts block -->
    @if (phones().length) {
      <div class="footer__block">
        <h4 class="footer__heading">Контакти</h4>
        <ul class="footer__list">
          @for (phone of phones(); track phone) {
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.06 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
              <a [href]="phoneHref(phone)">{{ formatPhone(phone) }}</a>
            </li>
          }
        </ul>
      </div>
    }

  </div>

  <div class="footer__bottom">
    <span>© {{ currentYear }} MilkHouse. Всі права захищені.</span>
  </div>
</footer>
